import { TaxReturn, TaxQuestion, ReturnSet } from "./types";
import { useFormeBackendApi } from "@modules/forme/queries";
import { useQuery } from "react-query";
import request from "@common/request";

const useGetTaxReturns = () => {
  return useFormeBackendApi<TaxReturn[]>({
    method: "GET",
    path: `/v1/tax/returns`,
  });
};

const useGetTaxReturnQuestions = (returnId: string) => {
  return useFormeBackendApi<TaxQuestion[]>({
    method: "GET",
    path: `/v1/tax/returns/${returnId}/questions`,
  });
};

const useGetReturnSets = (year: string) => {
  return useFormeBackendApi<ReturnSet[]>({
    method: "GET",
    path: `/v1/tax/return-sets?year=${year}`,
  });
};

const useAdminGetReturnsByHouseholdId = (householdId: string) => {
  return useQuery(["adminTaxReturns", householdId], () =>
    request<TaxReturn[]>("GET", "/api/advisor/tax/returns", { householdId })
  );
};

export {
  useGetTaxReturns,
  useGetTaxReturnQuestions,
  useGetReturnSets,
  useAdminGetReturnsByHouseholdId,
};
